class PasswordResetUsersController {
  static controller($scope, $state, PasswordResetService) {
    'ngInject';
    $scope.resetPasswordSubmit = function(passwordResetForm) {

      if(!passwordResetForm.$valid){
        console.error('invalid passwordResetForm');
        return;
      }

      var promise = PasswordResetService.generateClientPasswordResetToken(passwordResetForm.email.$modelValue);

      promise.then(function(){
        $state.go('public.users.password-reset-sent', {login: passwordResetForm.email.$modelValue});
      });
    }
  };
}

export default PasswordResetUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/password-reset.users.controller.js